import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

const ShortCutViewModel = () => {
  const roleId = useAuthStore(state => state.profile?.roleId ?? 0, shallow)
  const clearState = useAuthStore(state => state.clearState, shallow)

  const checkPermission = (permissionConfig: number[], roleId: number) => {
    return permissionConfig.includes(roleId)
  }

  const signOut = () => {
    clearState()
  }

  return { signOut, roleId, checkPermission }
}

export default ShortCutViewModel
